import { handleActions } from 'redux-actions';
import { getAutomatedWithdrawalsSuccess, getAutomatedWithdrawalsFail } from '../actions';

const defaultState = {
  failedChecks: [],
  passedPercent: [],
};

export default handleActions(
  {
    [getAutomatedWithdrawalsSuccess]: (state, action) => {
      const { type } = action.payload;

      if (type === 'failedChecks') {
        return {
          ...state,
          failedChecks: action.response.data,
        };
      } else if (type === 'passedPercent') {
        return {
          ...state,
          passedPercent: action.response.data,
        };
      }

      return state;
    },
    [getAutomatedWithdrawalsFail]: () => {
      return defaultState;
    },
  },
  defaultState,
);
